import dispatcher from "./../Dispatcher/Dispatcher";
import Access_ControlConstants from "../Constants/Access_ControlConstants";

function HttpRequest(url, typ, body, callback) {
  var xmlHttp = new XMLHttpRequest();

  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState === 4 && xmlHttp.status === 200) {
      var res = null;
      var message = "";
      try {
        res = JSON.parse(xmlHttp.response);
      } catch (err) {
        res = xmlHttp.response;
      }

      callback(res);
    } else {
      if (xmlHttp.readyState === 4) {
        res = "Error";

        if (xmlHttp.response && xmlHttp.response.body) {
          message = xmlHttp.response.body;
        }
        callback(res, message);
        if (
          xmlHttp.response &&
          xmlHttp.response.code == "User_LoginSessionExpired"
        ) {
          dispatcher.dispatch({
            type: Access_ControlConstants.SESSION_EXPIRED,
            result: xmlHttp.response.body,
          });
        }
      } else {
        //      console.error("RESPONSE: " + xmlHttp.status + " " + xmlHttp.statusText);
        //nichts tun, da hier nur verschiedene phasen des reuqests durchlaufen werden
      }
    }
  };

  xmlHttp.open(typ, url, true); // true for asynchronous

  //do the authentication if available request.Headers.Authorization = new AuthenticationHeaderValue("Bearer", accessToken);

  var token = sessionStorage.getItem("token");
  if (token !== null) {
    xmlHttp.setRequestHeader("Authorization", "Bearer " + token);
  } else {
    //sonst wird der header nicht gesetzt
  }

  xmlHttp.responseType = "json";
  if (
    url.includes("Export") ||
    url.includes("ExportWithImage") ||
    url.includes("ExportUeberfaellige") ||
    url.includes("ExportStammdaten") ||
    url.includes("ExportNIOAnlage") ||
    url.includes("ExportUeberfaellige") ||
    url.includes("OpenDocument") ||
    url.includes("GeneratePruefbericht") ||
    url.includes("GenerateManualWithAcceptanceProtocol") ||
    url.includes("GetScheduledEmailAttachment")
    // ||
    // url.includes("GetTemplate")
  ) {
    xmlHttp.responseType = "blob";
  }

  if (body !== null) {
    xmlHttp.setRequestHeader("Content-Type", "application/json");
  }
  xmlHttp.send(body);
}

export default HttpRequest;
